import { useState, useCallback } from 'react';

let globalShowAuthModal = null;

export const useAuthModal = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalMessage, setAuthModalMessage] = useState("You must be logged in to perform this action");

  const showAuthModal = useCallback((message) => {
    if (message) setAuthModalMessage(message);
    setIsAuthModalOpen(true);
  }, []);

  const hideAuthModal = useCallback(() => {
    setIsAuthModalOpen(false);
  }, []);

  // Set global reference
  globalShowAuthModal = showAuthModal;

  return {
    isAuthModalOpen,
    authModalMessage,
    showAuthModal,
    hideAuthModal
  };
};

// Global function to show auth modal from anywhere
export const showGlobalAuthModal = (message) => {
  if (globalShowAuthModal) {
    globalShowAuthModal(message);
  }
};